import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'
import Home from './views/Home.vue'

Vue.use(Router)

let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Jobs',
			component: () => import(/* webpackChunkName: "jobs" */ './views/jobs/Jobs.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/jobs/new',
			name: 'New Job',
			component: () => import(/* webpackChunkName: "addjob" */ './views/jobs/AddJob.vue'),
			meta: { authorize: ['Super Admin'] }
		},
		{
			path: '/job/:id',
			name: 'Job',
			component: () => import(/* webpackChunkName: "viewjob" */ './views/jobs/Job.vue'),
			meta: { authorize: ['Super Admin'] }
		},
		{
			path: '/job/:id/edit',
			name: 'Edit Job',
			component: () => import(/* webpackChunkName: "editjob" */ './views/jobs/AddJob.vue'),
			meta: { authorize: ['Super Admin'] }
		},
		{
			path: '/job/:id/order',
			name: 'Create Order',
			component: () => import(/* webpackChunkName: "joborder" */ './views/orders/NewOrder.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/job/:id/orderforecast',
			name: 'Forecast Order',
			component: () => import(/* webpackChunkName: "joborder" */ './views/orders/NewOrder.vue'),
			meta: { authorize: ['Super Admin','Administrator','Regional Manager'] }
		},
		// {
		// 	path: '/job/:id/orderforecast/:type',
		// 	name: 'Forecast Order',
		// 	component: () => import(/* webpackChunkName: "joborder" */ './views/orders/NewOrder.vue'),
		// 	meta: { authorize: [] }
		// },
		{
			path: '/orders',
			name: 'All Orders',
			component: () => import(/* webpackChunkName: "orders" */ './views/orders/Orders.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/reports',
			name: 'Reports',
			component: () => import(/* webpackChunkName: "orders" */ './views/reports/Report.vue'),
			meta: { authorize: ['Super Admin','Administrator','Accounts'] }
		},
		{
			path: '/orders/new',
			name: 'All Orders To Pull',
			component: () => import(/* webpackChunkName: "orders" */ './views/orders/OrderPullingList.vue'),
			meta: { authorize: ['Head Office Storeman'] }
		},
		{
			path: '/orders/process/:fcorderid/',
			name: 'OrderProcessing',
			component: () => import(/* webpackChunkName: "joborder" */ './views/orders/ProcessOrder.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Regional Manager'] }
		},
		{
			path: '/orders/:regionid/pulled',
			name: 'All Pulled Orders',
			component: () => import(/* webpackChunkName: "orders" */ './views/orders/OrderDisptachingList.vue'),
			meta: { authorize: ['Driver'] }
		},
		{
			path: '/job/:id/orders/new',
			name: 'Job Orders To Pull',
			component: () => import(/* webpackChunkName: "joborders" */ './views/orders/OrderPullingList.vue'),
			meta: { authorize: ['Head Office Storeman'] }
		},
		{
			path: '/job/:id/orders',
			name: 'Job Orders',
			component: () => import(/* webpackChunkName: "joborders" */ './views/orders/Orders.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/forecasts',
			name: 'Forecasts',
			alias: ['/reticulation'],
			component: () => import(/* webpackChunkName: "addjob" */ './views/forecast/RegionChoice.vue'),
			meta: { authorize: ['Super Admin', 'Administrator'] }
		},
		{
			path: '/forecasts/:forecastid/breakdown',
			name: 'Forecast Order Details Breakdown',
			component: () => import(/* webpackChunkName: "joborders" */ './views/forecast/ForecastOrderDetail.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts','Store Man', 'Site Manager', 'Regional Manager', 'Reticulation Manager'] }
		},
		{
			path: '/forecasts/:regionid/history',
			name: 'Forecast History',
			component: () => import(/* webpackChunkName: "joborder" */ './views/forecast/ForecastHistory.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Regional Manager'] }
		},
		{
			path: '/forecasts/:regionid/review',
			name: 'Review Processed Region Forecasts',
			component: () => import(/* webpackChunkName: "joborder" */ './views/forecast/ReviewProcessedRegionForecasts.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Regional Manager'] }
		},
		{
			path: '/forecasts/:regionid/:type',
			name: 'Regional Forecasts',
			component: () => import(/* webpackChunkName: "joborder" */ './views/forecast/ForecastRegionListing.vue'),
			meta: { authorize: ['Super Admin', 'Accounts', 'Administrator', 'Regional Manager'] }
		},
		{
			path: '/job/:id/:type/process',
			name: 'Processing Job Forecast',
			component: () => import(/* webpackChunkName: "joborders" */ './views/forecast/JobForecastProcessing.vue'),
			meta: { authorize: ['Super Admin', 'Accounts', 'Administrator'] }
		},
		{
			path: '/job/:id/:type/:areaid/process',
			name: 'Area Forecast Processing',
			component: () => import(/* webpackChunkName: "joborders" */ './views/forecast/JobAreaForecastProcessing.vue'),
			meta: { authorize: ['Super Admin', 'Accounts', 'Administrator'] }
		},
		{
			path: '/job/:id/forecasts/',
			name: 'Job Forecast Details',
			component: () => import(/* webpackChunkName: "joborders" */ './views/forecast/JobForecastDetail.vue'),
			meta: { authorize: ['Super Admin', 'Administrator','Store Man', 'Site Manager', 'Regional Manager', 'Reticulation Manager'] }
		},
		{
			path: '/job/:id/orders/:orderid',
			name: 'Job Order Detail',
			component: () => import(/* webpackChunkName: "joborderdetail" */ './views/orders/OrderDetail.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/job/:id/orders/cable/:orderid',
			name: 'Job Order Detail - Reticulation',
			component: () => import(/* webpackChunkName: "joborderdetail" */ './views/orders/OrderDetailsCable.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/job/:id/orders/new/:orderid',
			name: 'Job Order Detail To Pull',
			component: () => import(/* webpackChunkName: "joborderdetail" */ './views/orders/OrderPullingDetail.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Head Office Storeman', 'Regional Manager'] }
		},
		{
			path: '/job/:id/orders/pulled/:orderid',
			name: 'Job Order Detail To Despatch',
			component: () => import(/* webpackChunkName: "joborderdetail" */ './views/orders/OrderDispatchingDetail.vue'),
			meta: { authorize: ['Driver'] }
		},
		{
			path: '/jobs/:id/sitewarehouse',
			name: 'Job Site Warehouse',
			component: () => import(/* webpackChunkName: "sitewarehouse" */ './views/jobs/SiteWarehouse.vue'),
			meta: { authorize: [] }
		},
		{
			path: '/forecastorders',
			name: 'Forecast Orders',
			component: () => import(/* webpackChunkName: "addjob" */ './views/forecast/listOrders.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Head Office Storeman'] }
		},
		{
			path: '/forecastorders/:orderrefid',
			name: 'Forecast Order Received',
			component: () => import(/* webpackChunkName: "addjob" */ './views/forecast/fcOrderDetail.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Head Office Storeman'] }
		},
		{
			path: '/forecastorders/nostock/:orderrefid',
			name: 'Forecast Order Received - No Stock',
			component: () => import(/* webpackChunkName: "addjob" */ './views/forecast/fcOrderDetailNoStock.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Head Office Storeman'] }
		},
		{
			path: '/jobs/:id/templates',
			name: 'Job templates',
			component: () => import(/* webpackChunkName: "addjob" */ './views/templates/ShowTemplates.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Head Office Storeman'] }
		},
		{
			path: '/about',
			name: 'About',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
			meta: { authorize: ['Super Admin'] }
		},
		{
			path: '/login',
			name: 'Login',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
		},
		{
			path: '/reset',
			name: 'Reset',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
		},
		{
			path: '/products/import',
			name: 'ImportProducts',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "import" */ './views/products/Import.vue'),
			meta: { authorize: ['Super Admin', 'Accounts', 'Administrator'] }
		},
		{
			path: '/products/remove',
			name: 'RemoveStock',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "import" */ './views/products/RemoveStock.vue'),
			meta: { authorize: ['Super Admin', 'Accounts', 'Administrator'] }
		},
		{
			path: '/stock/:id',
			name: 'Stock',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "import" */ './views/stock/Stock.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Head Office Storeman', 'Regional Manager'] }
		},
		{
			path: '/stock/stock-allocation/:id',
			name: 'StockAllocation',
			// route level code-splitting
			// this generates a separate chunk (login.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "import" */ './views/stock/StockAllocation.vue'),
			meta: { authorize: ['Super Admin', 'Administrator', 'Accounts', 'Head Office Storeman', 'Regional Manager'] }
		}
	]
})

router.beforeEach((to, from, next) => {
	//console.log(to);
	const { authorize } = to.meta
	//	const currentUser = store.getters.getUser;
	const isLoggedIn = store.getters['auth/token']

	if (authorize) {
		if (!isLoggedIn) {
			// not logged in so redirect to login page with the return url
			store.commit('setStatus', { message: 'Please log in first', type: 'info' })
			return next({ path: '/login', query: { returnUrl: to.fullPath } })
		}
		// check if route is restricted by role
		if (authorize.length && !authorize.includes(store.getters['auth/role'])) {
			// role not authorised so redirect to home page
			return next({ path: '/' })
		}
	}

	next()
})

export default router
